import { combineReducers } from "redux";
import {
  CREATE_OFFICES_REQUEST,
  FETCH_OFFICES_REQUEST,
  UPDATE_OFFICES_REQUEST,
  UPDATE_OFFICES_WEIGHT_REQUEST,
} from "../constants";
import { FETCH_DOCTOR_REQUEST } from "../../doctor/constants";
import { Action } from "../types";
import { Action as DoctorAction } from "../../doctor/types";
import { getFailureActionType, getSuccessActionType } from "../../utils";
import { Office } from "../../types";

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_OFFICES_REQUEST:
      return true;
    case getSuccessActionType(FETCH_OFFICES_REQUEST):
    case getFailureActionType(FETCH_OFFICES_REQUEST):
      return false;

    default:
      return state;
  }
}

function items(state: Office[] = [], action: Action | DoctorAction): Office[] {
  let selectedOffice = null;
  switch (action.type) {
    case getSuccessActionType(FETCH_OFFICES_REQUEST):
      return action.payload;

    case getSuccessActionType(FETCH_DOCTOR_REQUEST):
      return action.payload.offices;

    case getSuccessActionType(CREATE_OFFICES_REQUEST):
      return [...state, action.payload];

    case getSuccessActionType(UPDATE_OFFICES_REQUEST):
    case getSuccessActionType(UPDATE_OFFICES_WEIGHT_REQUEST):
      selectedOffice = state.map((office) => (office.id === action.data.officeId ? action.payload : office));
      return selectedOffice;

    default:
      return state;
  }
}

export const offices = combineReducers({ items, isFetching });
